<template>
  <div class="el-section">
    <anticipation-list></anticipation-list>
  </div>
</template>

<script>
import '@pagarme/anticipation-list/web-comp'

export default {
  name: 'AnticipationsList'
}
</script>
